// Mock data for Nitaara Lifesciences website
import who from '../assets/who-gmp.webp'
import agedm from '../assets/adedm.webp';
import eucador from '../assets/Ecuador.webp'
import costrica from '../assets/COSTRICA.webp'
import venzual from '../assets/Venezuela.webp'
import dominicRepublic from '../assets/dominicanRepublic.webp'
import gobiero from '../assets/gobiero.webp'
import hondurus from '../assets/honduras.webp'

export const navigationMenu = [
  { key: 'home', path: '/', hasDropdown: false },
  { key: 'company', path: '/about', hasDropdown: false },
  {
    key: 'products',
    path: '/products',
    hasDropdown: true,
    submenu: [
      { key: 'oncology', path: '/products/oncology' },
      { key: 'injections', path: '/products/injections' },
      { key: 'infusions', path: '/products/infusions' },
    ]
  },
  { key: 'rd', path:'/rd', hasDropdown: false},
  { key: 'bussiness development', path: '/quality', hasDropdown: false },
  { key: 'global', path: '/global', hasDropdown: false }
];
  
  export const heroContent = {
    subtitle: 'Welcome. This is Curevion Saludis',
    title: 'Healthcare Solutions You Can Rely On',
    description: 'At Curevion Saludis, we are committed to improving the health and well-being of people worldwide by providing high-quality pharmaceutical products. Guided by innovation, compassion, and care, we create medicines that help enhance and improve everyday life.',
    ctaText: 'Explore More',
    ctaLink: '/about'
  };
  
  export const statistics = [
    { value: '500+', label: 'Molecules' },
    { value: '12+', label: 'Global Presence' },
    { value: '100+', label: 'Clinical Trials' }
  ];
  
  export const regulatoryApprovals = [
    { name: 'WHO-GMP', logo: who },
    { name: 'AGEMED Bolivia', logo: agedm },
    { name: 'MISPA, Ecuador', logo: eucador },
    { name: 'MOH, Costa Rica', logo: costrica },
    { name: 'MOH, Dominican Republic', logo: dominicRepublic },
    { name: 'MSPAS, Guatemala', logo: gobiero },
    { name: 'MOH, Venezuela', logo: venzual },
    { name: 'MOH, Honduras', logo: hondurus }
  ];
  
  export const aboutContent = {
    subtitle: 'Our Vision & Mission',
    title: 'Working for Better Health.',
    description: 'Backed by a solid foundation in manufacturing and distribution, Nitaara Lifesciences has built a respected position in the pharmaceutical sector. We cater to both prescription and over-the-counter segments, delivering a diverse portfolio that includes tablets, soft and hard gelatin capsules, oral liquids, injectables, and ophthalmic formulations.',
    // image: 'https://nitaaralifesciences.com/assets/Who%20We%20Are-DUSLKWhb.jpg',
    certified: 'WHO-GMP Certified',
    standard: 'Global Quality Standard'
  };
  
  export const qualityContent = {
    subtitle: 'Quality Commitment',
    title: 'Dedicated to Quality & Excellence',
    description: 'At Curevion Saludis, quality is our highest priority. From the careful selection of raw materials to the final delivery of our products, every stage of our manufacturing process follows strict quality control standards. Our modern, state-of-the-art facilities are equipped with advanced technology to ensure that all our products meet international regulatory guidelines.',
    ctaText: 'Want to Learn More?',
    ctaLink: '/quality',
    features: [
      'Advanced Diagnostic Testing You Can Trust. Providing High-Quality, Modern Diagnostic Solutions.',
      'Leading the Way in Complete Drug Development Solutions. Expertise Across Every Stage of Drug Development.'
    ],
    // image: 'https://nitaaralifesciences.com/assets/qualityAssurance-TgqKtcyD.webp'
  };
  
  export const products = [
    {
      id: 1,
      title: 'Infusions',
      description: 'Large Volume Parenterals (LVPs) are aqueous solutions generally supplied in volumes ranging from 100 ml to 5000 ml.',
      // image: 'https://nitaaralifesciences.com/assets/Infusiones-CH8g0sXo.webp'
    },
    {
      id: 2,
      title: 'Injections',
      description: 'A Small Volume Parenteral is any sterile pharmaceutical preparation packaged in a volume of 50 ml or less.',
      // image: 'https://nitaaralifesciences.com/assets/Inyecciones-CaHXp5_k.webp'
    },
    {
      id: 3,
      title: 'Oncology',
      description: 'Developing advanced cancer treatments to improve survival rates and quality of life.',
      // image: 'https://nitaaralifesciences.com/assets/Oncolog%C3%ADa-mSJpgiuR.webp'
    }
  ];
  
  export const whyUsContent = {
    subtitle: 'Why Choose Us',
    title: 'The Advantage of Choosing Curevion Saludis',
    // image: 'https://nitaaralifescences.com/assets/Why%20Us-DSv8xGhG.webp',
    reasons: [
      {
        title: 'Uncompromising Quality:',
        description: 'Every product is manufactured under strict quality control standards to ensure safety, purity, and effectiveness.'
      },
      {
        title: 'Advanced Manufacturing:',
        description: 'State-of-the-art facilities equipped with modern technology to meet global regulatory requirements.'
      },
      {
        title: 'Innovation-Driven Approach:',
        description: 'We continuously invest in research and development to deliver advanced and effective healthcare solutions.'
      },
      {
        title: 'Wide Product Portfolio:',
        description: 'From tablets and capsules to injectables and ophthalmic solutions, we offer a comprehensive range.'
      },
      {
        title: 'Commitment to Care:',
        description: 'Beyond medicines, we are dedicated to improving lives through responsible and accessible healthcare.'
      }
    ]
  };
  
  export const contactInfo = {
    whatsappNumber: '919496900000',
    whatsappMessage: 'Hi Nitaara Lifesciences, I visited your website and would like to know more about your products.'
  };